import React from 'react'

import { PrelineStyle, PrelineProps } from './Preline.types'

export const defaultStyle: PrelineStyle = {
  colorScheme: {
    primary: 'color-scheme-primary',
    secondary: 'color-scheme-secondary'
  },
  textPosition: {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  }
}

const Preline = ({
  children,
  colorScheme = 'primary',
  textPosition = 'left',
  className = ''
}: PrelineProps) => {
  const cssClasses: string[] = [
    'preline',
    defaultStyle.colorScheme[colorScheme],
    defaultStyle.textPosition[textPosition],
    className
  ]

  return <div className={cssClasses.join(' ')}>{children}</div>
}

export default Preline
